<template>
  <div>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="message.snackbar"
      :timeout="message.snackbarTimeout"
      bottom
    >
      {{ message.snackbarText }}
      <v-btn dark text @click="message.snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="collectUserDataDialog" scrollable max-width="600px">
      <v-card>
        <v-card-title>Bespoke question</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formCollectUserData">
            <v-radio-group v-model="collectUserData.questionType" row>
              <v-radio label="Question" value="QUESTION"></v-radio>
              <v-radio label="Employee" value="EMPLOYEE"></v-radio>
            </v-radio-group>
            <v-text-field
              v-model="collectUserData.label"
              label="Field name"
              :rules="[rules.required]"
              required
            ></v-text-field>
            <v-select
              v-if="collectUserData.questionType !== 'EMPLOYEE'"
              v-model="collectUserData.validation"
              multiple
              :items="validationChecks"
              :rules="[rules.required]"
              label="Validation check"
            ></v-select>
            <v-select
              v-model="collectUserData.fieldType"
              v-if="collectUserData.questionType !== 'EMPLOYEE'"
              :items="formTypes"
              :rules="[rules.required]"
              label="Dropdown, free text"
            ></v-select>
            <v-combobox
              v-if="collectUserData.fieldType == 'select'"
              v-model="collectUserData.select"
              label="Add select options"
              multiple
              chips
            ></v-combobox>
            <v-text-field
              v-if="
                collectUserData.fieldType !== 'checkbox' &&
                  collectUserData.questionType == 'PREQUESTION'
              "
              v-model="collectUserData.success"
              label="Success value"
              :rules="[rules.required]"
              required
            ></v-text-field>
            <v-textarea
              v-if="
                collectUserData.fieldType !== 'checkbox' &&
                  collectUserData.questionType == 'PREQUESTION'
              "
              v-model="collectUserData.error"
              label="Error message"
              :rules="[rules.required]"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="collectUserDataDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="createCollectUserData()"
            text
            class="hp--btn"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="updateCollectUserDataDialog"
      scrollable
      max-width="600px"
    >
      <v-card>
        <v-card-title>Update bespoke question</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formUpdateCollectUserData">
            <v-radio-group
              v-model="collectUserData.questionType"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Question" value="QUESTION"></v-radio>
              <v-radio label="Employee" value="EMPLOYEE"></v-radio>
            </v-radio-group>
            <v-text-field
              v-model="collectUserData.label"
              label="Field name"
              :rules="[rules.required]"
              required
            ></v-text-field>
            <v-select
              v-model="collectUserData.validation"
              multiple
              :items="validationChecks"
              :rules="[rules.required]"
              label="Validation check"
            ></v-select>
            <v-select
              v-if="collectUserData.questionType !== 'EMPLOYEE'"
              v-model="collectUserData.fieldType"
              :items="formTypes"
              :rules="[rules.required]"
              label="Dropdown, free text"
            ></v-select>
            <v-combobox
              v-if="collectUserData.fieldType == 'select'"
              v-model="collectUserData.select"
              label="Add select options"
              multiple
              chips
            ></v-combobox>
            <v-text-field
              v-if="
                collectUserData.fieldType !== 'checkbox' &&
                  collectUserData.questionType == 'PREQUESTION'
              "
              v-model="collectUserData.success"
              label="Success value"
              :rules="[rules.required]"
              required
            ></v-text-field>
            <v-text-field
              v-if="collectUserData.questionType !== 'EMPLOYEE'"
              v-model="collectUserData.hint"
              label="Hint"
            ></v-text-field>
            <v-textarea
              v-if="collectUserData.questionType == 'PREQUESTION'"
              v-model="collectUserData.error"
              label="Error message"
              :rules="[rules.required]"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="updateCollectUserDataDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="updateCollectUserData()"
            text
            class="hp--btn"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1"
          >Create register interest</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2"
          >Bespoke questions</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 3" step="3"
          >Add the locations</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 4" step="4">Complete</v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form ref="formEvent">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="event.name"
                  label="Event name"
                  :rules="[rules.required]"
                  required
                ></v-text-field>

                <v-select
                  v-model="event.status"
                  :items="eventStatus"
                  label="Status"
                  :rules="[rules.required]"
                ></v-select>

                <v-select
                  v-model="event.clientAccess"
                  multiple
                  :items="clientAccessList"
                  label="Provide client access"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="event.code"
                  label="Code"
                  :rules="[rules.required]"
                  disabled
                ></v-text-field>
                <v-select
                  v-model="event.commsTemplate"
                  :items="commsTemplates"
                  label="Comms template"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  v-model="event.type"
                  :items="eventTypes"
                  :rules="[rules.required]"
                  label="Type"
                  disabled
                ></v-select>
                <v-menu
                  ref="expiryMenu"
                  v-model="expiryMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="expiryDate"
                      label="Date"
                      hint="DD/MM/YYYY format"
                      persistent-hint
                      v-bind="attrs"
                      v-on="on"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="expiry"
                    no-title
                    @input="expiryMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="6">
                <v-textarea
                  v-model="event.message"
                  rows="3"
                  label="Message"
                ></v-textarea>
              </v-col>

              <v-col cols="6" style="padding-left: 12px">
                <v-textarea
                  v-model="event.description"
                  rows="3"
                  label="Description"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :right="true"
                @click="createUpdateEvent()"
                class="hp--btn"
                >Continue</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-stepper-content>

        <v-stepper-content
          step="2"
          style="position: relative; min-height: 220px"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mt-6 mr-4 hp--btn"
                color="blue"
                dark
                small
                absolute
                right
                top
                fab
                v-on="on"
                @click="
                  collectUserData = {};
                  openCollectData();
                "
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>New custom field</span>
          </v-tooltip>
          <v-card flat outlined>
            <v-list-item>
              <v-list-item-content>
                <div class="overline mb-4">CUSTOM DATA FIELDS</div>

                <v-card
                  flat
                  v-for="userdata in collectUserDatas"
                  :key="userdata.id"
                >
                  <v-divider></v-divider>
                  <v-layout row wrap class="ma-1">
                    <v-flex sm1>
                      <v-chip
                        small
                        class="mt-3 white--text"
                        color="blue"
                        v-if="userdata.questionType === 'EMPLOYEE'"
                        >EMP</v-chip
                      >
                      <v-chip
                        small
                        class="mt-3 white--text"
                        color="red"
                        v-if="userdata.questionType === 'PREQUESTION'"
                        >PRE</v-chip
                      >
                      <v-chip
                        small
                        class="mt-3 white--text"
                        color="green"
                        v-if="userdata.questionType === 'QUESTION'"
                        >QUE</v-chip
                      >
                    </v-flex>
                    <v-flex sm2 class="py-1 px-2">
                      <div class="caption grey--text">Field label</div>
                      {{ userdata.label }}
                    </v-flex>
                    <v-flex sm1 class="py-1">
                      <div class="caption grey--text">Field type</div>
                      {{ userdata.fieldType }}
                    </v-flex>
                    <v-flex sm3 class="py-1">
                      <div class="caption grey--text">Validation</div>
                      <v-chip
                        small
                        class="mr-1"
                        v-for="val in userdata.validation"
                        :key="val"
                        >{{ val }}</v-chip
                      >
                    </v-flex>
                    <v-flex sm3 class="py-1">
                      <div class="caption grey--text">Options</div>
                      <v-chip
                        small
                        class="mr-1"
                        v-for="opt in userdata.options"
                        :key="opt.id"
                        >{{ opt.options }}</v-chip
                      >
                    </v-flex>
                    <v-flex sm2 class="py-2">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="mx-2 float-right mr-3 hp--btn"
                            @click="deleteCollectUserData(userdata.id)"
                            fab
                            dark
                            x-small
                            color="error"
                          >
                            <v-icon v-on="on" dark>delete_outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete custom fields</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="mx-2 float-right hp--btn"
                            @click="openCustomDataFields(userdata.id)"
                            fab
                            dark
                            x-small
                            color="success"
                          >
                            <v-icon v-on="on" dark>edit</v-icon>
                          </v-btn>
                        </template>
                        <span>Update custom fields</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          <v-card-actions>
            <v-btn
              color="primary"
              :right="true"
              @click="goToEvent()"
              class="hp--btn"
              >Back</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :right="true"
              @click="step = 3"
              class="hp--btn"
              >Continue</v-btn
            >
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-data-table
            v-model="selectedLocations"
            :headers="locationHeaders"
            :items="locations"
            :single-select="false"
            item-key="id"
            show-select
            class="elevation-1"
          ></v-data-table>

          <v-card-actions>
            <v-btn color="primary" :right="true" @click="step = 2">Back</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :right="true"
              @click="saveLocations()"
              class="hp--btn"
              >Continue</v-btn
            >
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-layout text-center wrap>
            <v-flex xs12>
              <v-img
                :src="require('../assets/green-tick.png')"
                class="my-3"
                contain
                height="120"
              ></v-img>
            </v-flex>

            <v-flex xs12>
              <h1 class="display-1">
                {{ company.name }} ({{ event.code }}) register interest slots
                have been created!
              </h1>
            </v-flex>
            <v-flex xs12>
              <v-card class="grey lighten-4 ml-1 pa-5 my-5">
                <v-layout text-left wrap>
                  <v-row no-gutters style="flex-wrap: nowrap">
                    <v-col cols="12" class="flex-grow-0 flex-shrink-0">
                      <v-flex
                        xs12
                        class="headline red--text text--darken-4 my-5"
                        >The register interest slot created:</v-flex
                      >

                      <v-flex xs12 class="body-2">
                        <v-flex xs12 class="body-2">
                          <ul
                            v-for="group in computedSlotGroupDates"
                            :key="group"
                          >
                            <li class="body-1">
                              {{ new Date(group) | moment("Do MMMM YYYY") }}
                            </li>
                          </ul>
                        </v-flex>
                      </v-flex>
                    </v-col>
                  </v-row>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import moment from "moment";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import * as mutations from "./../graphql/mutations";
import { CustomField } from "../classes/CustomField";
import _ from "lodash";

export default {
  components: {},
  data() {
    return {
      step: 1,
      loader: false,
      rules: {
        required: v => !!v || "This field is required.",
        requiredArray: v => v.length > 0 || "This field is required."
      },
      company: [],
      event: {},
      eventGroupSlot: {
        date: []
      },
      location: {},
      locations: [],
      eventLocations: [],
      selectedLocations: [],
      locationHeaders: [
        {
          text: "Address 1",
          align: "left",
          sortable: false,
          value: "addressLine1"
        },
        { text: "Address 2", value: "addressLine2" },
        { text: "Town", value: "town" },
        { text: "Postcode", value: "postcode" }
      ],
      slotGroups: [],
      slotGroupsCopy: [],
      collectUserData: {},
      collectUserDatas: [],
      eventGroup: {
        date: new Date().toISOString().substr(0, 10)
      },
      staff: [],
      eventTypes: [
        { text: "Slot", value: "slot" },
        { text: "Workshop", value: "workshop" },
        { text: "Register Interest", value: "register" },
        { text: "Health Screening", value: "healthscreening" },
        { text: "Virus Testing", value: "virustesting" }
      ],
      eventStatus: ["Draft", "Live", "Paused"],
      iCalendar: ["Yes", "No"],
      formTypes: [
        { text: "Checkbox", value: "checkbox" },
        { text: "Select", value: "select" },
        { text: "Text", value: "text" }
      ],
      validationChecks: [
        { text: "Required", value: "required" },
        { text: "Email", value: "email" }
      ],
      clientAccessList: [],
      preQuestionTemplate: [{ text: "Flu questions", value: "fluQuestions" }],
      commsTemplates: [],
      eventLocationDialog: false,
      updateEventLocationDialog: false,
      eventRoomDialog: false,
      eventGroupDialog: false,
      collectUserDataDialog: false,
      updateCollectUserDataDialog: false,
      date: new Date().toISOString().substr(0, 10),
      eventDate: false,
      eventGroupDate: false,
      eventGroupForm: {
        length: []
      },
      begins: "",
      length: "",
      menu: false,
      questionFabMenu: false,
      minDateAllowed: moment().toISOString(),
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000
      },
      expiryMenu: false,
      expiry: new Date().toISOString().substr(0, 10),
      expiryDate: null
    };
  },
  created() {
    this.getEventDetails();
  },
  methods: {
    openEventLocation(slot) {
      this.eventGroupSlot = { date: [], start: "08:00", end: "17:30" };
      this.event.slot = slot;
      this.eventRoomDialog = true;
    },
    openCollectData() {
      this.collectUserDataDialog = true;
    },
    goToEvent() {
      this.getEventDetails();
      this.step = 1;
    },
    openUpdateEventDialog(groupId) {
      if (groupId) {
        const getEventSlotGroup = /* GraphQL */ `
          query GetEventSlotGroup($id: ID!) {
            getEventSlotGroup(id: $id) {
              id
              room
              date
              capacity
              createdAt
              isDeleted
              assignedTo
              eventLocation {
                id
                addressLine1
                addressLine2
                town
                postcode
                createdAt
                eventLocationLookupId
                isDeleted
              }
              eventSlot {
                items {
                  id
                  time
                  length
                  type
                  booked
                  isDeleted
                }
              }
            }
          }
        `;
        // Update event
        API.graphql(
          graphqlOperation(getEventSlotGroup, {
            id: groupId
          })
        ).then(result => {
          this.eventGroup.id = result.data.getEventSlotGroup.id;
          this.eventGroup.date = new Date(result.data.getEventSlotGroup.date)
            .toISOString()
            .substr(0, 10);
          this.eventGroup.room = result.data.getEventSlotGroup.room;
          this.eventGroup.capacity = result.data.getEventSlotGroup.capacity;
          this.eventGroup.location =
            result.data.getEventSlotGroup.eventLocation.id;
          this.eventGroup.assignedTo = JSON.parse(
            result.data.getEventSlotGroup.assignedTo
          );

          this.eventGroupSlot.start = result.data.getEventSlotGroup.eventSlot.items.map(
            () =>
              result.data.getEventSlotGroup.eventSlot.items[0].time.substr(0, 5)
          );

          this.eventGroupSlot.end = result.data.getEventSlotGroup.eventSlot.items.map(
            () =>
              result.data.getEventSlotGroup.eventSlot.items[0].time.substr(8, 5)
          );
          this.eventGroupDialog = true;
        });
      }
    },
    async openCustomDataFields(id) {
      if (id) {
        const collectUserData = await CustomField.getCustomFields(id);
        let collectUserDataOptions = collectUserData.eventCollectUserDataOptions.items.map(
          item => item.options
        );
        collectUserDataOptions = collectUserDataOptions.sort();

        this.collectUserData = {
          id: collectUserData.id,
          label: collectUserData.label,
          questionType: collectUserData.questionType,
          validation: collectUserData.validation,
          fieldType: collectUserData.fieldType,
          success: collectUserData.success,
          hint: collectUserData.hint,
          error: collectUserData.error,
          isDeleted: collectUserData.isDeleted,
          select: collectUserDataOptions
        };
        this.updateCollectUserDataDialog = true;
      }
    },
    getEventDetails() {
      this.loader = true;
      this.slotGroups = [];
      this.eventLocations = [];
      this.collectUserDatas = [];
      const getEvent = `query GetEvent($id: ID!) {
            getEvent(id: $id) {
                id
                name
                code
                type
                requireDob
                iCalendar
                status
                message
                description
                commsTemplate
                preQuestionTemplate
                clientAccess
                createdAt
                eventCompany {
                  id
                  name
                  createdAt
                  isDeleted
                  eventClientAccess {
                    items {
                      id
                      description
                    }
                  }
                }
                eventLocation (
                  filter: {
                    isDeleted: { eq: 0 }
                  }
                ) {
                    items {
                        id
                        addressLine1
                        addressLine2
                        town
                        postcode
                        eventLocationLookupId
                        createdAt
                        isDeleted
                        eventSlotGroup(
                          limit: 1000
                          filter: {
                            isDeleted: { eq: 0 }
                          }
                        ) {
                            items {
                                id,
                                room,
                                capacity,
                                date,
                                assignedTo,
                                createdAt,
                                eventSlot(
                                  filter: {
                                      isDeleted: { eq: 0 }
                                  },
                                  limit: 1000
                                ) {
                                    items {
                                        id,
                                        length,
                                        time,
                                        type,
                                        booked
                                        eventBooking(
                                          filter: {
                                            isDeleted: { eq: 0 }
                                          },
                                          limit: 1000
                                        ) {
                                            items {
                                              id,
                                              firstname,
                                              lastname
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    nextToken
                }
                eventCollectUserData(
                  filter: {
                      isDeleted: { eq: 0 }
                  }
                ) {
                  items {
                    id,
                    label,
                    questionType,
                    validation,
                    fieldType,
                    success,
                    error,
                    createdAt,
                    isDeleted,
                    eventCollectUserDataOptions {
                      items {
                        id,
                        options
                      }
                    }
                  }
                }
            }
        }
        `;
      API.graphql(
        graphqlOperation(getEvent, {
          id: this.$route.params.eventId
        })
      ).then(result => {
        const that = this;
        const event = result.data.getEvent;
        this.company = event.eventCompany;

        event.eventCompany.eventClientAccess.items.forEach(function(
          clientAccess
        ) {
          that.clientAccessList.push({
            text: clientAccess.description,
            value: clientAccess.id
          });
          that.clientAccess = _.orderBy(
            that.clientAccess,
            "description",
            "asc"
          );
        });
        this.event = {
          id: event.id,
          code: event.code,
          createdAt: event.createdAt,
          name: event.name,
          type: event.type,
          booked: event.booked,
          commsTemplate: event.commsTemplate,
          preQuestionTemplate: null,
          icalendar: "No",
          status: event.status,
          message: event.message,
          description: event.description,
          clientAccess: event.clientAccess
        };
        event.eventLocation.items.forEach(function(location) {
          location.eventSlotGroup.items.forEach(function(group) {
            let slots = group.eventSlot.items;
            slots = slots.map(slot => {
              let colour = {};
              switch (slot.length) {
                case 5:
                  colour = { colour: "error" };
                  break;
                case 15:
                  colour = { colour: "pink lighten-1" };
                  break;
                case 20:
                  colour = { colour: "purple darken-1" };
                  break;
                case 30:
                  colour = { colour: "indigo lighten-1" };
                  break;
                case 45:
                  colour = { colour: "indigo accent-2" };
                  break;
                case 60:
                  colour = { colour: "cyan darken-2" };
                  break;
                default:
                  colour = { colour: "info" };
              }
              return { ...slot, ...colour };
            });
            let sorted = slots.sort(
              (a, b) =>
                new Date("1970/01/01 " + a.time.substring(0, 5)) -
                new Date("1970/01/01 " + b.time.substring(0, 5))
            );
            that.slotGroups.push({
              id: group.id,
              room: group.room,
              capacity: group.capacity,
              date: group.date,
              assignedTo: JSON.parse(group.assignedTo),
              createdAt: group.createdAt,
              slots: sorted,
              filter: false
            });
            that.expiryDate = moment(group.date).format("DD/MM/YYYY");
          });
          that.eventLocations.push({
            id: location.id,
            addressLine1: location.addressLine1,
            addressLine2: location.addressLine2,
            town: location.town,
            postcode: location.postcode,
            eventLocationLookupId: location.eventLocationLookupId
          });
        });
        event.eventCollectUserData.items.forEach(function(collectUserData) {
          that.collectUserDatas.push({
            id: collectUserData.id,
            label: collectUserData.label,
            questionType: collectUserData.questionType,
            validation: collectUserData.validation,
            fieldType: collectUserData.fieldType,
            success: collectUserData.success,
            hint: collectUserData.hint,
            error: collectUserData.error,
            options: _.orderBy(
              collectUserData.eventCollectUserDataOptions.items,
              "options",
              "asc"
            )
          });
        });
        that.collectUserDatas = _.orderBy(
          that.collectUserDatas,
          "label",
          "asc"
        );
        this.commsTemplatesSelect();
        this.locationLookup();
        this.loader = false;
      });
    },
    async createUpdateEvent() {
      if (this.$refs.formEvent.validate()) {
        if (this.event.id) {
          API.graphql(
            graphqlOperation(mutations.updateEvent, {
              input: {
                id: this.event.id,
                name: this.event.name,
                code: this.event.code.toLowerCase(),
                type: this.event.type,
                requireDob: false,
                iCalendar: false,
                status: this.event.status,
                message: this.event.message ? this.event.message : null,
                description: this.event.description
                  ? this.event.description
                  : null,
                createdAt: new Date().toISOString(),
                commsTemplate: this.event.commsTemplate,
                preQuestionTemplate: this.event.preQuestionTemplate,
                eventEventCompanyId: this.company.id,
                clientAccess: this.event.clientAccess
              }
            })
          ).then(result => {
            const eventResult = result.data.updateEvent;
            this.event = {
              id: eventResult.id,
              code: eventResult.code.toLowerCase(),
              name: eventResult.name,
              requireDob: eventResult.requireDob,
              commsTemplate: eventResult.commsTemplate,
              type: eventResult.type === "yes" ? true : false,
              icalendar: false,
              status: eventResult.status
            };
            this.step = 2;
          });

          // Update event
          API.graphql(
            graphqlOperation(queries.getEvent, {
              id: this.event.id
            })
          ).then(result => {
            this.event = {
              id: result.data.getEvent.id,
              code: result.data.getEvent.code.toLowerCase(),
              name: result.data.getEvent.name,
              requireDob: result.data.getEvent.requireDob,
              type: result.data.getEvent.type,
              icalendar: result.data.getEvent.type,
              status: result.data.getEvent.type
            };
            this.step = 2;
          });
        } else {
          // Create event
          API.graphql(
            graphqlOperation(mutations.createEvent, {
              input: {
                name: this.event.name,
                code: this.event.code.toLowerCase(),
                type: this.event.type,
                requireDob: 0,
                createdAt: new Date().toISOString(),
                eventEventCompanyId: this.company.id
              }
            })
          ).then(result => {
            const eventResult = result.data.createEvent;
            this.event = {
              id: eventResult.id,
              code: eventResult.code.toLowerCase(),
              name: eventResult.name,
              requireDob: eventResult.requireDob,
              type: eventResult.type
            };
            this.step = 2;
          });
        }
      }
    },
    async nextCommsTemplate(nextToken) {
      const {
        data: { listEventCommsTemplates: templates }
      } = await API.graphql({
        query: queries.listEventCommsTemplates,
        variables: {
          limit: 100,
          filter: { isDeleted: { eq: 0 } },
          nextToken: nextToken
        }
      });
      return templates;
    },
    async commsTemplatesSelect() {
      var that = this;
      let templates = await this.nextCommsTemplate(null);
      let templateItems = templates.items;
      while (templates.nextToken !== null) {
        templates = await this.nextCommsTemplate(templates.nextToken);
        templateItems.push(...templates.items);
      }
      const templatelist = templateItems.map(template => ({
        text: template.name,
        value: template.id
      }));
      that.commsTemplates = _.orderBy(templatelist, "text", "asc");
    },
    locationLookup() {
      const that = this;
      that.selectedLocations = [];
      that.locations = [];
      const lookup = `query GetEventCompany($id: ID!) {
              getEventCompany(id: $id) {
                eventLocationLookup(filter: {isDeleted: {eq: 0}}) {
                  items {
                    id
                    postcode
                    town
                    addressLine1
                    addressLine2
                    createdAt
                    isDeleted
                  }
                }
              }
            }`;
      // Update event
      API.graphql(
        graphqlOperation(lookup, {
          id: this.company.id
        })
      ).then(result => {
        const locationLookups =
          result.data.getEventCompany.eventLocationLookup.items;

        locationLookups.forEach(function(locationLookup) {
          that.locations.push({
            id: locationLookup.id,
            addressLine1: locationLookup.addressLine1,
            addressLine2: locationLookup.addressLine2,
            town: locationLookup.town,
            postcode: locationLookup.postcode
          });
          that.eventLocations.forEach(function(location) {
            if (locationLookup.id === location.eventLocationLookupId) {
              that.selectedLocations.push({
                id: locationLookup.id,
                postcode: locationLookup.postcode,
                town: locationLookup.town,
                addressLine1: locationLookup.addressLine1,
                addressLine2: locationLookup.addressLine2,
                createdAt: locationLookup.createdAt,
                isDeleted: locationLookup.isDeleted,
                eventLocationId: location.id
              });
            }
          });
        });
      });
    },
    async saveLocations() {
      const that = this;

      const getEvent = `query GetEvent($id: ID!, $eventLocationLookupId: String!) {
        getEvent(id: $id) {
          eventLocation(filter: {isDeleted: {eq: 0}, eventLocationLookupId: {eq: $eventLocationLookupId}}) {
            items {
              id
              isDeleted
              postcode
              town
              eventLocationLookupId
              createdAt
              addressLine2
              addressLine1
            }
          }
        }
      }
      `;

      that.selectedLocations.forEach(location => {
        API.graphql(
          graphqlOperation(getEvent, {
            id: that.event.id,
            eventLocationLookupId: location.id
          })
        ).then(() => {
          if (that.slotGroups.length === 0) {
            API.graphql(
              graphqlOperation(mutations.createEventLocation, {
                input: {
                  addressLine1: location.addressLine1,
                  addressLine2: location.addressLine2,
                  town: location.town,
                  postcode: location.postcode,
                  createdAt: new Date().toISOString(),
                  eventLocationLookupId: location.id,
                  eventLocationEventId: that.event.id,
                  isDeleted: 0
                }
              })
            ).then(async result => {
              const location = result.data.createEventLocation;
              that.eventLocations.push(location);

              API.graphql(
                graphqlOperation(mutations.createEventSlotGroup, {
                  input: {
                    room: "N/A",
                    date: moment(this.expiryDate, "DD/MM/YYYY").toISOString(),
                    capacity: 1000,
                    createdAt: new Date().toISOString(),
                    active: true,
                    isDeleted: 0,
                    eventSlotGroupEventLocationId: location.id
                  }
                })
              ).then(async result => {
                let slotBatches = [];
                slotBatches.push({
                  time: "08:00 - 17:30",
                  length: parseInt(570),
                  type: "register",
                  eventSlotEventSlotGroupId:
                    result.data.createEventSlotGroup.id,
                  booked: 0,
                  isDeleted: 0
                });

                const createBatchEventSlot = batch => {
                  return new Promise(async resolve => {
                    API.graphql(
                      graphqlOperation(mutations.createBatchEventSlot, {
                        slots: batch
                      })
                    ).then(result => {
                      resolve(result.data.createBatchEventSlot);
                    });
                  });
                };

                // Run slot batches
                await Promise.all(
                  slotBatches.map(
                    async batch => await createBatchEventSlot(batch)
                  )
                );
              });
            });
          } else {
            if (that.slotGroups[0].id) {
              API.graphql(
                graphqlOperation(mutations.updateEventSlotGroup, {
                  input: {
                    id: that.slotGroups[0].id,
                    date: moment(this.expiryDate, "DD/MM/YYYY").toISOString()
                  }
                })
              );
            }
          }
          that.step = 4;
        });
      });
    },
    async createCollectUserData() {
      if (this.$refs.formCollectUserData.validate()) {
        let that = this;
        if (this.collectUserData.questionType === "EMPLOYEE") {
          this.collectUserData.fieldType = "text";
          this.collectUserData.validation = [];
          this.collectUserData.validation.push("required");
        }

        const collectUserData = await CustomField.createBespokeQuestion(
          this.event.id,
          this.collectUserData
        );

        that.collectUserDatas.push({
          id: collectUserData.id,
          questionType: collectUserData.questionType,
          label: collectUserData.label,
          validation: collectUserData.validation,
          fieldType: collectUserData.fieldType,
          success: that.collectUserData.success,
          hint: that.collectUserData.hint,
          error: that.collectUserData.error,
          options: []
        });

        if (
          that.collectUserData.select !== undefined &&
          that.collectUserData.fieldType === "select"
        ) {
          that.collectUserData.select.forEach(function(option) {
            API.graphql(
              graphqlOperation(mutations.createEventCollectUserDataOptions, {
                input: {
                  options: option,
                  eventCollectUserDataOptionsEventCollectUserDataId:
                    collectUserData.id,
                  isDeleted: 0
                }
              })
            ).then(result => {
              that.collectUserDatas[
                that.collectUserDatas.length - 1
              ].options.push({
                id: result.data.createEventCollectUserDataOptions.id,
                options: result.data.createEventCollectUserDataOptions.options
              });
            });
          });
        }
        that.collectUserDataDialog = false;
      }
    },
    updateCollectUserData() {
      const that = this;
      if (that.$refs.formUpdateCollectUserData.validate()) {
        const updateEventCollectUserData = /* GraphQL */ `
          mutation UpdateEventCollectUserData(
            $input: UpdateEventCollectUserDataInput!
            $condition: ModelEventCollectUserDataConditionInput
          ) {
            updateEventCollectUserData(input: $input, condition: $condition) {
              id
              label
              questionType
              validation
              fieldType
              createdAt
              success
              error
              hint
              isDeleted
              eventCollectUserDataOptions {
                items {
                  id
                  options
                  isDeleted
                }
              }
            }
          }
        `;
        API.graphql(
          graphqlOperation(updateEventCollectUserData, {
            input: {
              id: that.collectUserData.id,
              questionType: that.collectUserData.questionType,
              label: that.collectUserData.label,
              validation: that.collectUserData.validation,
              fieldType: that.collectUserData.fieldType,
              success: that.collectUserData.success,
              hint: that.collectUserData.hint,
              error: that.collectUserData.error
            }
          })
        ).then(result => {
          const collectUserData = result.data.updateEventCollectUserData;
          collectUserData.eventCollectUserDataOptions.items.forEach(function(
            option
          ) {
            API.graphql(
              graphqlOperation(mutations.deleteEventCollectUserDataOptions, {
                input: {
                  id: option.id
                }
              })
            );
          });
          const index = that.collectUserDatas.findIndex(
            data => data.id === collectUserData.id
          );

          that.collectUserDatas[index] = {
            id: collectUserData.id,
            questionType: collectUserData.questionType,
            label: collectUserData.label,
            validation: collectUserData.validation,
            fieldType: collectUserData.fieldType,
            success: collectUserData.success,
            options: []
          };

          if (
            that.collectUserData.select !== undefined &&
            that.collectUserData.fieldType === "select"
          ) {
            let options = [];
            that.collectUserData.select.forEach(function(option) {
              API.graphql(
                graphqlOperation(mutations.createEventCollectUserDataOptions, {
                  input: {
                    options: option.trim(),
                    eventCollectUserDataOptionsEventCollectUserDataId:
                      collectUserData.id,
                    isDeleted: 0
                  }
                })
              ).then(result => {
                options.push({
                  id: result.data.createEventCollectUserDataOptions.id,
                  options: result.data.createEventCollectUserDataOptions.options.trim(),
                  isDeleted: 0
                });

                that.collectUserDatas[index].options = options;
              });
            });
          }
          that.updateCollectUserDataDialog = false;
        });
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    deleteCollectUserData(id) {
      if (confirm("Are you sure you want to delete the custom data field?")) {
        if (id) {
          API.graphql(
            graphqlOperation(mutations.updateEventCollectUserData, {
              input: {
                id: id,
                isDeleted: 1
              }
            })
          ).then(result => {
            this.collectUserDatas = this.collectUserDatas.filter(
              data => data.id !== result.data.updateEventCollectUserData.id
            );
          });
        }
      }
    }
  },
  computed: {
    computedSlotGroupDates() {
      let dates = [];
      this.slotGroups.map(function(group) {
        if (!dates.includes(group.date)) {
          dates.push(group.date);
        }
      });
      return dates;
    },
    computedLocationsSelectOptions() {
      return this.eventLocations.map(location => ({
        text: location.postcode,
        value: location.id
      }));
    }
  },
  watch: {
    expiry() {
      this.expiryDate = this.formatDate(this.expiry);
    }
  }
};
</script>
